export type Message = {
	role: string
	value: string
}

export enum Role {
	HUMAN = 'human',
	IA = 'ia',
}
